import { isRejectedWithValue, Middleware } from "@reduxjs/toolkit";
import { FirebaseError } from "firebase/app";

export const firebaseErrorLogger: Middleware = () => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const error = action.payload;

    if (error instanceof FirebaseError) {
      if (error.code === "permission-denied") {
        console.group("🚫 Firebase permission error");
        console.error("Code :", error.code);
        console.error("Message :", error.message);
        console.error("Action :", action.meta?.arg);
        console.groupEnd();
      } else {
        console.group("❌ Firebase error");
        console.error("Code :", error.code);
        console.error("Message :", error.message);
        console.groupEnd();
      }
    } else if (typeof error === "string") {
      // cas de rejectWithValue("Accès interdit") ou autre
      console.warn("⚠️ Rejected with string payload:", error);
    }
  }

  return next(action);
};
